import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { items } = useWishlist();

  return (
    <div className="min-h-screen pt-[68px] lg:pt-[116px]" data-testid="wishlist-page">
      <div className="section-dark px-5 py-16 sm:px-8">
        <div className="mx-auto max-w-[1400px]">
          <p className="mb-3 font-mono text-xs uppercase tracking-overline text-[#34D8A0]">Saved For Later</p>
          <h1 className="font-display text-5xl font-extrabold tracking-tighter sm:text-6xl">Wishlist</h1>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-5 py-12 sm:px-8">
        {items.length === 0 ? (
          <div className="flex flex-col items-center gap-6 py-24 text-center" data-testid="empty-wishlist">
            <Heart className="h-12 w-12 text-black/20" />
            <p className="font-display text-2xl font-semibold">Your wishlist is empty</p>
            <Link to="/shop" className="rounded-full bg-black px-8 py-3 font-semibold text-white transition-colors hover:bg-[#2F80ED]">
              Browse Formulas
            </Link>
          </div>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="wishlist-grid">
            {items.map((it, i) => (
              <ProductCard key={it.product_id} product={{ ...it, id: it.product_id }} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
